import CRUDService from "./geral/CRUDService";

export default class LocalTrabalhoService extends CRUDService{
    constructor() {
        super("localacesso");
    }
}